import { ChangeDetectionStrategy, Component, Input } from '@angular/core';
import { ModalController } from '@ionic/angular';
import { TypologyDto } from '@timechef/core/api';

@Component({
  selector: 'app-typologies-modal',
  templateUrl: './typologies-modal.component.html',
  styleUrls: ['./typologies-modal.component.scss'],
  changeDetection: ChangeDetectionStrategy.OnPush,
  standalone: false,
})
export class TypologiesModalComponent {
  @Input() title = '';
  @Input() subtitle = '';
  @Input() typologies?: TypologyDto[];

  constructor(private modalCtrl: ModalController) {}

  async dismissModal() {
    await this.modalCtrl.dismiss();
  }
}
